import React from 'react';

function Button({
    text,
    onClick,
    type = 'button',
    className = '',
    color = 'white',
    backgroundColor = '#007AFF',
    hoverBackgroundColor,
    hoverColor,
    disabled = false,
    size = 'medium' // New prop with default value
}) {
    // Function to darken the color
    function darkenColor(color, percent) {
        let R = parseInt(color.substring(1, 3), 16);
        let G = parseInt(color.substring(3, 5), 16);
        let B = parseInt(color.substring(5, 7), 16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        const RR = ((R.toString(16).length === 1) ? "0" + R.toString(16) : R.toString(16));
        const GG = ((G.toString(16).length === 1) ? "0" + G.toString(16) : G.toString(16));
        const BB = ((B.toString(16).length === 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
    }

    // Define size configurations
    const sizeConfig = {
        small: { padding: '8px 16px', fontSize: '14px' },
        medium: { padding: '10px 20px', fontSize: '16px' },
        large: { padding: '12px 24px', fontSize: '18px' }
    };

    // Use the size config or default to medium if an invalid size is provided
    const sizeStyle = sizeConfig[size] || sizeConfig.medium;

    // Inline styles with dynamic color, backgroundColor, and size
    const baseStyle = {
        ...sizeStyle, // Spread the size-specific styles
        margin: '10px 5px',
        backgroundColor: disabled ? '#cccccc' : backgroundColor,
        color: disabled ? '#666666' : color,
        borderRadius: '10px',
        border: 'none',
        boxShadow: disabled ? 'none' : '0 5px 5px rgba(0, 0, 0, 0.1)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        outline: 'none',
        transition: 'background-color 0.3s, box-shadow 0.3s',
        opacity: disabled ? 0.6 : 1
    };

    const handleMouseOver = e => {
        if (!disabled) {
            e.target.style.backgroundColor = hoverBackgroundColor ? hoverBackgroundColor : darkenColor(backgroundColor, -20);
            e.target.style.color = hoverColor ? hoverColor : color;
            e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
        }
    };

    const handleMouseOut = e => {
        if (!disabled) {
            e.target.style.backgroundColor = backgroundColor;
            e.target.style.color = color;
            e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)';
        }
    };

    const handleClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };

    return (
        <button
            className={`common-button ${className} ${disabled ? 'disabled' : ''}`}
            onClick={handleClick}
            type={type}
            style={baseStyle}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            disabled={disabled}
        >
            {text}
        </button>
    );
}

export default Button;